module.exports = __webpack_public_path__ + "img/shape.68e86876.svg";